 
import React from 'react';
import { Tabs } from 'antd';
import FieldConfigBuilder from './FieldConfigBuilder';
import FieldValidationBuilder from './FieldValidationBuilder';
import InterfaceActionBuilder from './InterfaceActionBuilder';
import FieldActionConfigBuilder from './FieldActionConfigBuilder';
import FieldVisibilityRulesBuilder from './FieldVisibilityRulesBuilder';

const items = [
    {
        key: '1',
        label: 'Interface Action Builder',
        children: <InterfaceActionBuilder />,
    },
    {
        key: '2',
        label: 'Field Config',
        children: <FieldConfigBuilder />,
    },
    {
        key: '3',
        label: 'Field Validation Config',
        children: <FieldValidationBuilder />,
    },
    {
        key: '4',
        label: 'Field Visibility Rules',
        children: <FieldVisibilityRulesBuilder />,
    },
    {
        key: '5',
        label: 'Field Action Config',
        children: <FieldActionConfigBuilder />,
    }
];
const FieldActionBuilder: React.FC = () => {
    return (
        <div style={{ padding: 20 }}>
            <Tabs defaultActiveKey="1" type="card" items={items}>
               
            </Tabs>
        </div>
    );
};

export default FieldActionBuilder;
